// Index file which imports our main app file (JS) and all other 3rd party assets to be bundled in assets/theme.js and assets/theme.css

import '../css/bootstrap/bootstrap.min.css';
import '../css/bootstrap/bootstrap-reboot.min.css';
import './fontawesome/fontawesome';
import './fontawesome/solid';
import './fontawesome/custom';
import '../sass/main.scss';
import {app} from './app';

app.init();